import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { genFetchedData } from 'redux/fetchedData';
import {
  tdToast,
} from 'utils/ToastUtils/toast';
import { toast } from 'react-toastify';
import updateToken from 'utils/updateToken';
import i18n from '../../../i18n';
import { sendMassCreativeAddTaskAPI, sendToGrid, updateDSP } from '../api';
import { setSendMassCreativeAddTask, setSendToGridData, setUploadDspData, SideMenuState } from '../reducer';

export function* workerUpdateDspSaga(): SagaIterator {
  let fetchedData = genFetchedData<SideMenuState['uploadDSPData']>(null).set(
    'isLoading',
    true,
  );
  yield put(setUploadDspData(fetchedData));

  let toastId: string | number | undefined;

  try {
    yield call(updateToken);
    toastId = tdToast('PENDING', i18n.t(`translations.dsp_precess`));
    const resp = yield call(updateDSP);
    if (resp) {
      if (toastId) {
        toast.dismiss(toastId);
      }
      tdToast('SUCCESS', `${i18n.t(`translations.dsp_updated`)}. Осталось кликов: ${resp.count}`);
    }
  } catch (e) {
    console.log({ e });
    if (toastId) {
      toast.dismiss(toastId);
    }
    tdToast('ERROR', i18n.t(`translations.dsp_error`))
  } finally {
    fetchedData = fetchedData.set('isLoading', false).set('LTU', Date.now());
    yield put(setUploadDspData(fetchedData));
  }
}

export function* workerSendToGridSaga(): SagaIterator {
  let fetchedData = genFetchedData<SideMenuState['sendToGridData']>(null).set(
    'isLoading',
    true,
  );
  yield put(setSendToGridData(fetchedData));

  let toastId: string | number | undefined;

  try {
    yield call(updateToken);
    toastId = tdToast('PENDING', i18n.t(`translations.dsp_precess`));
    const resp = yield call(sendToGrid);
    if (resp) {
      if (toastId) {
        toast.dismiss(toastId);
      }
      tdToast('SUCCESS', `Отправка в Grid прошла успешно. Осталось кликов: ${resp.count}`);
    }
  } catch (e) {
    console.log({ e });
    if (toastId) {
      toast.dismiss(toastId);
    }
    tdToast('ERROR', `Ошибка при отправке в Grid`)
  } finally {
    fetchedData = fetchedData.set('isLoading', false).set('LTU', Date.now());
    yield put(setUploadDspData(fetchedData));
  }
}

export function* workerSendMassCreativeAddTask(): SagaIterator {
  let fetchedData = genFetchedData<SideMenuState['sendMassCreativeAddTask']>(null).set(
    'isLoading',
    true,
  );
  yield put(setSendMassCreativeAddTask(fetchedData));

  let toastId: string | number | undefined;

  try {
    yield call(updateToken);
    toastId = tdToast('PENDING', i18n.t(`translations.dsp_precess`));
    const resp = yield call(sendMassCreativeAddTaskAPI);
    if (resp) {
      if (toastId) {
        toast.dismiss(toastId);
      }

      tdToast('SUCCESS', `Создание задачи прошло успешно`);
    }
  } catch (e) {
    console.log({ e });
    if (toastId) {
      toast.dismiss(toastId);
    }
    tdToast('ERROR', `Ошибка при создании задачи`)
  } finally {
    fetchedData = fetchedData.set('isLoading', false).set('LTU', Date.now());
    yield put(setSendMassCreativeAddTask(fetchedData));
  }
}
